// The double-scan guard: scanning the SAME barcode twice in a row must not
// score twice. The repeat is allowed operationally (the page decides what it
// means), but the points for it only come back once a DIFFERENT scan has
// happened in between — so scan-scan-scan on one box banks one award, while
// the honest cycle (item, location, item) keeps scoring because the location
// scan sits between the two item scans.
//
// Every scan submission funnels through HiddenScanInput (hardware burst,
// manual keyboard, camera), which notes each one here. Award code then asks
// one question at award time: was the scan that triggered this award
// identical to the scan before it?
//
// Device-scoped on purpose: flows never interleave on one handheld, and the
// guard surviving screen changes is what stops "leave the page, come back,
// rescan the same box" from re-arming it.

let prevScan: string | null = null;
let currScan: string | null = null;

/** Called by HiddenScanInput for every submitted scan, in order. */
export const noteScan = (value: string) => {
    prevScan = currScan;
    currScan = value;
};

/** True when the scan being processed right now repeats the one before it. */
export const currentScanIsRepeat = (): boolean =>
    currScan !== null && currScan === prevScan;

/** Test seam. */
export const __resetScanGuard = () => {
    prevScan = null;
    currScan = null;
};
